import React from 'react';
import { createIcon } from '@chakra-ui/react';

// Thin line icons for the workspace navigation, drawn on a 24px grid with a
// stroke so they sit at the same weight as the nav text.
const lineIcon = (displayName: string, path: React.ReactElement) =>
  createIcon({
    displayName,
    viewBox: '0 0 24 24',
    path: (
      <g fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        {path}
      </g>
    ),
  });

export const GalleriesIcon = lineIcon(
  'GalleriesIcon',
  <>
    <rect x="3" y="3" width="7" height="7" rx="1.5" />
    <rect x="14" y="3" width="7" height="7" rx="1.5" />
    <rect x="3" y="14" width="7" height="7" rx="1.5" />
    <rect x="14" y="14" width="7" height="7" rx="1.5" />
  </>
);

export const LibraryIcon = lineIcon(
  'LibraryIcon',
  <>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <circle cx="9" cy="10" r="1.6" />
    <path d="M21 16l-5-5-8 8" />
  </>
);

export const ProfileIcon = lineIcon(
  'ProfileIcon',
  <>
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21c0-4 3.6-6 8-6s8 2 8 6" />
  </>
);

export const UsageIcon = lineIcon(
  'UsageIcon',
  <>
    <path d="M4 20V10M10 20V4M16 20v-7M22 20H2" />
  </>
);

export const BillingIcon = lineIcon(
  'BillingIcon',
  <>
    <rect x="2" y="5" width="20" height="14" rx="2" />
    <path d="M2 10h20M6 15h4" />
  </>
);

export const AdminIcon = lineIcon(
  'AdminIcon',
  <>
    <path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6l8-3z" />
  </>
);

export const OverviewIcon = lineIcon(
  'OverviewIcon',
  <>
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <path d="M3 9h18M9 21V9" />
  </>
);

export const UsersIcon = lineIcon(
  'UsersIcon',
  <>
    <circle cx="9" cy="8" r="3.5" />
    <path d="M2 20c0-3.5 3-5.5 7-5.5s7 2 7 5.5" />
    <path d="M16 4.5a3.5 3.5 0 010 7M18.5 14.8c2 .7 3.5 2.4 3.5 5.2" />
  </>
);

export const ApprovalsIcon = lineIcon(
  'ApprovalsIcon',
  <>
    <circle cx="12" cy="12" r="9" />
    <path d="M8 12.5l2.8 2.8L16 10" />
  </>
);

export const StorageIcon = lineIcon(
  'StorageIcon',
  <>
    <ellipse cx="12" cy="5.5" rx="8" ry="2.5" />
    <path d="M4 5.5v13c0 1.4 3.6 2.5 8 2.5s8-1.1 8-2.5v-13M4 12c0 1.4 3.6 2.5 8 2.5s8-1.1 8-2.5" />
  </>
);

export const SystemIcon = lineIcon(
  'SystemIcon',
  <>
    <rect x="3" y="4" width="18" height="6" rx="1.5" />
    <rect x="3" y="14" width="18" height="6" rx="1.5" />
    <path d="M7 7h.01M7 17h.01" />
  </>
);

export const CommunityIcon = lineIcon(
  'CommunityIcon',
  <>
    <path d="M21 12a8 8 0 01-11.6 7.1L4 20l1-4.6A8 8 0 1121 12z" />
  </>
);

export const SignOutIcon = lineIcon(
  'SignOutIcon',
  <>
    <path d="M15 4h3a2 2 0 012 2v12a2 2 0 01-2 2h-3M10 17l5-5-5-5M15 12H4" />
  </>
);
